// Client Evidence content — code-based (no database).
// Add a new record by appending an object below. Set featured:true to show on the homepage.
export const EVIDENCE = [
  {
    "slug": "acuver-consulting",
    "org": "Acuver Consulting",
    "person": "Sunny Nandwani",
    "role": "Managing Director",
    "supported": "Award recognition, media visibility and executive positioning",
    "engagement_type": "Award & Recognition",
    "platform": "Times of India · Outlook Awards",
    "outcome": "Supported leadership recognition and executive visibility through an awards platform and a Times of India leadership feature.",
    "evidence_type": "Published article & award photograph",
    "image": "",
    "featured": true,
    "evidence_url": "https://timesofindia.indiatimes.com/business/india-business/beyond-the-boardroom-unveiling-the-minds-of-visionary-leaders-in-india-2023/articleshow/105228466.cms",
    "id": "acuver-consulting",
    "order": 0,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "everestengineering",
    "org": "EverestEngineering",
    "person": "Mr. Ragnathan",
    "role": "CEO",
    "supported": "Media visibility and leadership recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported executive visibility through a Times of India leadership-focused feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/business/india-business/beyond-the-boardroom-unveiling-the-minds-of-visionary-leaders-in-india-2023/articleshow/105228466.cms",
    "id": "everestengineering",
    "order": 1,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "sugar-fit",
    "org": "Sugar.fit",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through inclusion in a Times of India healthcare feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/life-style/health-fitness/health-news/top-5-promising-healthcare-companies-in-india-2023/articleshow/99669771.cms",
    "id": "sugar-fit",
    "order": 2,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "btl-india",
    "org": "BTL India",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through inclusion in a Times of India healthcare feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/life-style/health-fitness/health-news/top-5-promising-healthcare-companies-in-india-2023/articleshow/99669771.cms",
    "id": "btl-india",
    "order": 3,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "kirloskar-technologies",
    "org": "Kirloskar Technologies Pvt Ltd",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through inclusion in a Times of India healthcare feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/life-style/health-fitness/health-news/top-5-promising-healthcare-companies-in-india-2023/articleshow/99669771.cms",
    "id": "kirloskar-technologies",
    "order": 4,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "doceree-media-india",
    "org": "Doceree Media India",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through inclusion in a Times of India healthcare feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/life-style/health-fitness/health-news/top-5-promising-healthcare-companies-in-india-2023/articleshow/99669771.cms",
    "id": "doceree-media-india",
    "order": 5,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "doconline",
    "org": "DOCOnline",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through inclusion in a Times of India healthcare feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/life-style/health-fitness/health-news/top-5-promising-healthcare-companies-in-india-2023/articleshow/99669771.cms",
    "id": "doconline",
    "order": 6,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "flowtech-forbes-india",
    "org": "Flowtech Measuring Instruments Pvt Ltd",
    "person": "Rohan Shah",
    "role": "CEO",
    "supported": "Branded visibility and executive positioning",
    "engagement_type": "Branded Visibility",
    "platform": "Forbes India — Branded Content",
    "outcome": "Facilitated a Forbes India branded content feature (Brand Connect) positioning the CEO and organization.",
    "evidence_type": "Branded Content / Advertorial — magazine page",
    "image": "/evidence/flowtech_forbes.jpg",
    "featured": true,
    "evidence_url": "",
    "id": "flowtech-forbes-india",
    "order": 7,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "sut-hospital",
    "org": "SUT Multi Super Specialty Hospital",
    "person": "Col. Rajeev Mannali",
    "role": "CEO",
    "supported": "Award recognition and executive positioning",
    "engagement_type": "Award & Recognition",
    "platform": "Outlook India Awards",
    "outcome": "Supported leadership recognition through an established awards platform.",
    "evidence_type": "Award event photograph",
    "image": "/evidence/sut_rajeev_outlook.jpg",
    "featured": true,
    "evidence_url": "",
    "id": "sut-hospital",
    "order": 8,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "ambience-city-mall",
    "org": "Ambience City Mall Pvt Ltd",
    "person": "Arjun Singh Gehlot",
    "role": "Director",
    "supported": "Award recognition and executive positioning",
    "engagement_type": "Award & Recognition",
    "platform": "Outlook India Awards",
    "outcome": "Supported leadership recognition through an established awards platform.",
    "evidence_type": "Award event photograph",
    "image": "",
    "featured": false,
    "evidence_url": "",
    "id": "ambience-city-mall",
    "order": 9,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "sm-express-logistics",
    "org": "SM Express Logistics",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through a Times of India logistics feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/business/india-business/indias-top-3-persuasive-logistics-firms-of-2023/articleshow/102176381.cms",
    "id": "sm-express-logistics",
    "order": 10,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "pm-relocations",
    "org": "PM Relocations",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through a Times of India logistics feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/business/india-business/indias-top-3-persuasive-logistics-firms-of-2023/articleshow/102176381.cms",
    "id": "pm-relocations",
    "order": 11,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "celsius-logistics",
    "org": "Celsius Logistics",
    "person": "",
    "role": "Company-level engagement",
    "supported": "Media visibility and company recognition",
    "engagement_type": "Media Visibility",
    "platform": "Times of India",
    "outcome": "Supported corporate visibility through a Times of India logistics feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/business/india-business/indias-top-3-persuasive-logistics-firms-of-2023/articleshow/102176381.cms",
    "id": "celsius-logistics",
    "order": 12,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "step-global-dmcc",
    "org": "Step Global DMCC",
    "person": "Preeya Malik",
    "role": "Managing Director",
    "supported": "Media visibility and executive positioning",
    "engagement_type": "Executive Positioning",
    "platform": "Times of India — International Business",
    "outcome": "Supported executive visibility through a Times of India international business feature.",
    "evidence_type": "Published article",
    "image": "",
    "featured": false,
    "evidence_url": "https://timesofindia.indiatimes.com/business/international-business/why-all-us-f-1-international-students-should-consider-the-eb-5-green-card-program/articleshow/102104397.cms",
    "id": "step-global-dmcc",
    "order": 13,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "jb-boda-group",
    "org": "J.B. Boda Group",
    "person": "Gautam Boda",
    "role": "Group Vice Chairman",
    "supported": "Corporate visibility and executive positioning",
    "engagement_type": "Corporate Visibility",
    "platform": "ETBFSI — The Economic Times",
    "outcome": "Supported corporate and executive visibility within the BFSI ecosystem via ETBFSI coverage.",
    "evidence_type": "Published article",
    "image": "",
    "featured": true,
    "evidence_url": "https://bfsi.economictimes.indiatimes.com/news/insurance/j-b-boda-group-partners-with-parima-for-advancing-risk-management-standards-in-india/105552624",
    "id": "jb-boda-group",
    "order": 14,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "sgurrenergy",
    "org": "SgurrEnergy",
    "person": "",
    "role": "Company-level engagement",
    "supported": "International visibility and corporate positioning",
    "engagement_type": "International Visibility",
    "platform": "Khaleej Times",
    "outcome": "Supported international brand visibility through coverage in an established UAE publication.",
    "evidence_type": "Published article",
    "image": "",
    "featured": true,
    "evidence_url": "https://www.khaleejtimes.com/kt-network/sgurrenergy-achieves-milestone-of-81gw-worldwide-expands-presence-globally-with-riyadh-office-in-s",
    "id": "sgurrenergy",
    "order": 15,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "waisl-tedx",
    "org": "WAISL",
    "person": "Rishi Mehta",
    "role": "President & CEO",
    "supported": "Speaking platform and executive visibility",
    "engagement_type": "Speaking",
    "platform": "TEDx",
    "outcome": "Supported thought-leadership positioning through a TEDx speaking opportunity.",
    "evidence_type": "Speaking / event photograph",
    "image": "/evidence/waisl_tedx.jpg",
    "featured": true,
    "evidence_url": "",
    "id": "waisl-tedx",
    "order": 16,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "waisl-times-award",
    "org": "WAISL",
    "person": "Rishi Mehta",
    "role": "President & CEO",
    "supported": "Award recognition and executive positioning",
    "engagement_type": "Award & Recognition",
    "platform": "Times of India",
    "outcome": "Supported leadership recognition through a Times of India awards platform.",
    "evidence_type": "Award event photograph",
    "image": "/evidence/waisl_toi_award.jpg",
    "featured": true,
    "evidence_url": "",
    "id": "waisl-times-award",
    "order": 17,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "netplus",
    "org": "NetPlus",
    "person": "Prem Ojha",
    "role": "Executive",
    "supported": "Award recognition and professional positioning",
    "engagement_type": "Award & Recognition",
    "platform": "Times of India",
    "outcome": "Supported executive recognition through a Times of India recognition platform.",
    "evidence_type": "Award event photograph",
    "image": "/evidence/netplus_prem.jpg",
    "featured": true,
    "evidence_url": "",
    "id": "netplus",
    "order": 18,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "kpmg",
    "org": "KPMG",
    "person": "Mr. Neeraj",
    "role": "Client relationship",
    "supported": "Client relationship — evidence to be expanded",
    "engagement_type": "Relationship",
    "platform": "",
    "outcome": "Documented working relationship retained in the evidence repository. Further evidence to follow.",
    "evidence_type": "Relationship on record",
    "image": "",
    "featured": false,
    "evidence_url": "",
    "id": "kpmg",
    "order": 19,
    "attribution": true,
    "status": "Active"
  },
  {
    "slug": "abb",
    "org": "ABB",
    "person": "Mr. Ajay",
    "role": "Client relationship",
    "supported": "Client relationship — evidence to be expanded",
    "engagement_type": "Relationship",
    "platform": "",
    "outcome": "Documented working relationship retained in the evidence repository. Further evidence to follow.",
    "evidence_type": "Relationship on record",
    "image": "",
    "featured": false,
    "evidence_url": "",
    "id": "abb",
    "order": 20,
    "attribution": true,
    "status": "Active"
  }
];

export const FEATURED_EVIDENCE = EVIDENCE.filter((r) => r.featured);
export const getEvidence = (slug) => EVIDENCE.find((r) => r.slug === slug);
